import React from "react";

const IShare = ({
  color = "#252526",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M11.8125 3.79167C11.8125 2.90571 11.0943 2.1875 10.2083 2.1875C9.32238 2.1875 8.60417 2.90571 8.60417 3.79167C8.60417 4.67762 9.32238 5.39583 10.2083 5.39583C11.0943 5.39583 11.8125 4.67762 11.8125 3.79167ZM12.6875 3.79167C12.6875 5.16087 11.5775 6.27083 10.2083 6.27083C8.83913 6.27083 7.72917 5.16087 7.72917 3.79167C7.72917 2.42246 8.83913 1.3125 10.2083 1.3125C11.5775 1.3125 12.6875 2.42246 12.6875 3.79167Z"
        fill={color}
      />
      <path
        d="M8.16667 3.79167C8.16667 2.66409 9.08075 1.75 10.2083 1.75C11.3359 1.75 12.25 2.66409 12.25 3.79167C12.25 4.91925 11.3359 5.83333 10.2083 5.83333C9.08075 5.83333 8.16667 4.91925 8.16667 3.79167Z"
        fill={color}
      />
      <path
        d="M11.8125 10.2083C11.8125 9.32238 11.0943 8.60417 10.2083 8.60417C9.32238 8.60417 8.60417 9.32238 8.60417 10.2083C8.60417 11.0943 9.32238 11.8125 10.2083 11.8125C11.0943 11.8125 11.8125 11.0943 11.8125 10.2083ZM12.6875 10.2083C12.6875 11.5775 11.5775 12.6875 10.2083 12.6875C8.83913 12.6875 7.72917 11.5775 7.72917 10.2083C7.72917 8.83913 8.83913 7.72917 10.2083 7.72917C11.5775 7.72917 12.6875 8.83913 12.6875 10.2083Z"
        fill={color}
      />
      <path
        d="M8.16667 10.2083C8.16667 9.08075 9.08075 8.16667 10.2083 8.16667C11.3359 8.16667 12.25 9.08075 12.25 10.2083C12.25 11.3359 11.3359 12.25 10.2083 12.25C9.08075 12.25 8.16667 11.3359 8.16667 10.2083Z"
        fill={color}
      />
      <path
        d="M5.39583 7C5.39583 6.11404 4.67762 5.39583 3.79167 5.39583C2.90571 5.39583 2.1875 6.11404 2.1875 7C2.1875 7.88596 2.90571 8.60417 3.79167 8.60417C4.67762 8.60417 5.39583 7.88596 5.39583 7ZM6.27083 7C6.27083 8.36921 5.16087 9.47917 3.79167 9.47917C2.42246 9.47917 1.3125 8.36921 1.3125 7C1.3125 5.63079 2.42246 4.52083 3.79167 4.52083C5.16087 4.52083 6.27083 5.63079 6.27083 7Z"
        fill={color}
      />
      <path
        d="M1.75 7C1.75 5.87242 2.66409 4.95833 3.79167 4.95833C4.91925 4.95833 5.83333 5.87242 5.83333 7C5.83333 8.12758 4.91925 9.04167 3.79167 9.04167C2.66409 9.04167 1.75 8.12758 1.75 7Z"
        fill={color}
      />
      <path
        d="M8.68335 4.75041L5.76668 6.50041L5.31665 5.74959L8.23332 3.99959L8.68335 4.75041Z"
        fill={color}
      />
      <path
        d="M8.68335 9.24959L8.23332 10.0004L5.31665 8.25041L5.76668 7.49959L8.68335 9.24959Z"
        fill={color}
      />
    </svg>
  );
};

export default IShare;
